export default "__VITE_ASSET__C6OW0gNk__"